import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { NoPingAppVideo } from '../../../../shared/noping-app-video';
import { EASE_OUT, MATRIX_GREEN } from '../constants';

export function NoPingAppMockup() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <motion.div ref={ref} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }} transition={{ duration: 0.45, ease: EASE_OUT }} className='mx-auto max-w-3xl'>
      <div className='overflow-hidden rounded-2xl border shadow-2xl' style={{ borderColor: `${MATRIX_GREEN}20` }}>
        <NoPingAppVideo />
      </div>
    </motion.div>
  );
}
